import { render } from "./LessonForm.vue?vue&type=template&id=33046de2"
import script from "./LessonForm.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/learning_module/components/lesson/LessonForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33046de2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33046de2', __exports__)) {
    api.reload('33046de2', __exports__)
  }
  
  module.hot.accept("./LessonForm.vue?vue&type=template&id=33046de2", () => {
    api.rerender('33046de2', render)
  })

}


export default __exports__